import { render, staticRenderFns } from "./ModalObservaciones.vue?vue&type=template&id=382938ee"
import script from "./ModalObservaciones.vue?vue&type=script&lang=js"
export * from "./ModalObservaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports